import { Events } from '@setplex/pureya'
import { mq, PLAYER } from '~/shared/mq'
import { logger } from './index.h'
import { PlayerMountedMessage } from './player-meta'
import { PlayerState } from './player-state'

/**
 * Map to store player states by their IDs
 */
export const players = new Map<string, PlayerState>()

/**
 * Find the first player instance that is mounted (at least) and visible (maybe).
 * This is ad hoc solution to handle cases when multiple players are rendered,
 * but this should not happen in normal conditions, because we expect only one player to be rendered at a time
 */
export function getActivePlayerState(
  ids: string[] | undefined
): PlayerState | undefined {
  if (ids == null || ids.length === 0) return

  let player: PlayerState | undefined
  for (const id of ids) {
    const p = players.get(id)
    if (p && p.mounted) {
      player = p // at least mounted
      if (player.visible) {
        break // preferably visible
      }
    }
  }

  return player
}

//
// Update players map based on player lifecycle events
//

// Listen for player instantiation events to create and store PlayerState instances
// After creating a PlayerState instance, it will listen to player's events by itself
// and update itself accordingly, without needing external state management
mq.on(`${PLAYER}/${Events.Player.Instantiation}`, ({ player, playerId }) => {
  let state = players.get(playerId)
  if (state) {
    logger.error(`player with id ${playerId} already exists! this should not happen.`) // prettier-ignore
  } else {
    state = new PlayerState(player)
    players.set(playerId, state)
    player.on('dispose', () => players.delete(playerId)) // clean up state on player dispose
  }
})

// Listen for player mounted/unmounted events from React
mq.on(PlayerMountedMessage, ({ player, mounted }) => {
  const playerId = player.id_
  const state = players.get(playerId)
  if (state) {
    state.render(mounted)
  } else {
    logger.error(`player with id ${playerId} does not exist! this should not happen.`) // prettier-ignore
  }
})
